import DefaultModal from '../../../../components/Modal/DefaultModal';
import React, { useCallback, useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

import { toast } from 'react-toastify';
import { Row, Form, Col, Button } from 'reactstrap';
import StatusService from '../../../status/service';
import ReasonService from '../../../reason/service';
import SubReasonService from '../../../subReason/service';
import FlexSelect from '../../../../components/Inputs/FlexSelect';
import ProtocolService from '../../service';
import Loader from 'react-loader-spinner';
import { useProtocolDefaultFieldsSettings } from 'views/fieldConfigs/hooks/useProtocolDefaultFieldsSettings';
import { validateFields } from 'views/Protocol/form/assets/functions';
import { useFetchUsersByRecordType } from 'views/Protocol/form/hooks/useFetchUsersByRecordType';
import { FlexControllerV2 } from 'components/FlexControllerInput/V2';

const ModelUpdateMultProtocols = ({
  isModalOpen,
  onModalToggle,
  ids,
  getProtocols,
  selectedRecordTypeId,
  selectedRecordType,
  isRecordTypeUsingSLA,
  onClearSelectedRows = () => {},
  ...props
}) => {
  const recordTypeId = selectedRecordTypeId.value;

  const { control, handleSubmit, errors, setValue } = useForm();
  const { users } = useFetchUsersByRecordType(recordTypeId);
  const [statusList, setStatusList] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [subreasons, setSubreasons] = useState([]);
  const [isRequired, setIsRequired] = useState(false);
  const [loading, setLoading] = useState(false);

  const closeModal = useCallback(() => {
    onModalToggle(false);
  }, [onModalToggle]);

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const { protocolDefaultFieldsDisplaySettings } =
    useProtocolDefaultFieldsSettings(selectedRecordTypeId.value);

  const usersOptions = (users || [])?.map(({ name, login }) => ({
    label: name,
    value: login
  }));

  const subreasonsOptions = (subreasons || [])?.map(({ id, name }) => ({
    label: name,
    value: id
  }));

  const reasonsOptions = (reasons || [])?.map(({ id, name }) => ({
    label: name,
    value: id
  }));

  useEffect(() => {
    StatusService.getByRecordType(selectedRecordTypeId.value)
      .then((response) => {
        const res = response.data.content;

        setStatusList(res);
      })
      .catch((err) => {
        const message =
          (err.response && err.response.data) || 'Erro ao carregar status/fase';
        toast.error(message, {
          autoClose: 3000,
          closeOnClick: true
        });
        closeModal();
      });
    ReasonService.getByRecordType(selectedRecordTypeId.value)
      .then((response) => {
        setReasons(response.data.content);
      })
      .catch((err) => {
        const message =
          (err.response && err.response.data) || 'Erro ao carregar motivos';
        toast.error(message, {
          autoClose: 3000,
          closeOnClick: true
        });
        closeModal();
      });
  }, [closeModal, selectedRecordType]);

  const onSubmit = async (data) => {
    const dataToSend = {
      ...data,
      user_id: data.user_id?.value,
      current_status: data.current_status?.id || data.current_status,
      reason_id: data.reason_id?.value || data.reason_id,
      subreason_id: data.subreason_id?.value || data.subreason_id,
      record_type_id: recordTypeId,
      data: ids
    };

    try {
      setLoading(true);
      setSubreasons([]);
      setIsRequired(false);
      let message;
      await ProtocolService.updateMultProtocols(dataToSend);

      message = 'protocolos atualizados com sucesso';
      toast.success(message, {
        autoClose: 3000,
        closeOnClick: true
      });
      closeModal();
      setLoading(false);
      getProtocols();
      onClearSelectedRows();
    } catch (err) {
      console.log(err);
      toast.error(' Erro ao atualizar o protocolo', {
        autoClose: 3000,
        closeOnClick: true
      });
      setLoading(false);
    }
  };

  const handleGetSubReasons = (event) => {
    const value = event;
    if (value) {
      setIsRequired(
        protocolDefaultFieldsDisplaySettings.subreason_id.isRequired
      );
      SubReasonService.getByReasonId(value)
        .then((response) => {
          setSubreasons(response.data.content);
        })
        .catch((err) => {
          const { data } = err.response;
          toast.error(data.message, {
            autoClose: 3000,
            closeOnClick: true
          });
          closeModal();
        });
    } else {
      setSubreasons([]);
      setIsRequired(false);
    }
  };

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Atualizar protocolos em lote"
      subtitle="Selecione o usuário ou status/fase para realizar a atualização."
      showCloseButton={false}
      modalContainerClasses="modal-md"
      closeModal={closeModal}
      {...props}
    >
      {loading ? (
        <Row className="justify-content-md-center">
          <Loader type="TailSpin" height={100} width={100} />
        </Row>
      ) : (
        <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Col md="12">
              <FlexControllerV2
                type="select"
                name="user_id"
                control={control}
                label="Responsável"
                options={usersOptions}
                placeholder="Selecione um responsável"
                errors={errors}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="12">
              <label className="form-control-label">Status/Fase</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    isClearable={true}
                    dataOptions={statusList}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    value={props.value}
                    valueController={setValue}
                    fieldName="current_status"
                    labelName="name"
                    valueName="id"
                  />
                )}
                control={control}
                name="current_status"
                defaultValue=""
              />
              <ErrorMessage
                errors={errors}
                name="current_status"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>
          {!isRecordTypeUsingSLA ? (
            <>
              <Row className="mb-3">
                <Col sm="12">
                  <label className="form-control-label">Motivo</label>
                  <Controller
                    render={(props) => (
                      <FlexSelect
                        dataOptions={reasonsOptions}
                        value={props.value}
                        valueController={setValue}
                        fieldName="reason_id"
                        labelName="label"
                        valueName="value"
                        isClearable={true}
                        closeMenuOnSelect={true}
                        portalTarget={true}
                        onChange={handleGetSubReasons}
                        isDisabled={
                          !protocolDefaultFieldsDisplaySettings.reason_id
                            .isActive
                        }
                      />
                    )}
                    control={control}
                    name="reason_id"
                    defaultValue=""
                  />

                  <ErrorMessage
                    errors={errors}
                    name="reason_id"
                    render={({ message }) => errorFormMessage(message)}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm="12">
                  <label className="form-control-label">Submotivo*</label>
                  <Controller
                    render={(props) => (
                      <FlexSelect
                        dataOptions={subreasonsOptions}
                        value={props.value}
                        valueController={setValue}
                        fieldName="subreason_id"
                        labelName="label"
                        valueName="value"
                        isClearable={true}
                        closeMenuOnSelect={true}
                        portalTarget={true}
                        isDisabled={
                          !protocolDefaultFieldsDisplaySettings.subreason_id
                            .isActive
                        }
                      />
                    )}
                    control={control}
                    name="subreason_id"
                    defaultValue=""
                    rules={validateFields(isRequired)}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="subreason_id"
                    render={({ message }) => errorFormMessage(message)}
                  />
                </Col>
              </Row>
            </>
          ) : null}

          <hr />
          <Button color="primary" type="submit">
            Salvar
          </Button>
          <Button color="danger" onClick={closeModal}>
            Voltar
          </Button>
        </Form>
      )}
    </DefaultModal>
  );
};

export default ModelUpdateMultProtocols;
